import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let Home = () => import('../views/Home.vue')
let About = () => import('../views/About.vue')
let Introduction = () => import('../views/Introduction.vue')
let Protection = () => import('../views/Protection.vue')
let development = () => import('../views/development.vue')
let Branch = () => import('../views/Branch.vue')
let certificate = () => import('../views/certificate.vue')
let International = () => import('../views/International.vue')
let domestic = () => import('../views/domestic.vue')
let product = () => import('../views/product.vue')
let productInfo = () => import('../views/productInfo.vue')
let news = () => import('../views/news.vue')
let newsDetails = () => import('../views/newsDetails.vue')
let videoCenter = () => import('../views/videoCenter.vue')
let contact = () => import('../views/contact.vue')
let download = () => import('../views/download.vue')
let home_09m = () => import('../views/home_09m.vue')
let productClass = () => import('../views/productClass.vue')
let productClass_info = () => import('../views/productClass_info.vue')
let productClass_info_class = () => import('../views/productClass_class.vue')

// 

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/',
    name: 'home_09m',
    component: home_09m
  },
  {
    path: '/productClass',
    name: 'productClass',
    component: productClass
  },{
    path: '/productClass_info',
    name: 'productClass_info',
    component: productClass_info
  },{
    path: '/productClass_info_class',
    name: 'productClass_info_class',
    component: productClass_info_class
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/Introduction',
    name: 'Introduction',
    component: Introduction
  },
  
  {
    path: '/development',
    name: 'development',
    component: development
  },
  {
    path: '/Branch',
    name: 'Branch',
    component: Branch
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: certificate
  },
  {
    path: '/International',
    name: 'International',
    component: International
  },
  {
    path: '/domestic',
    name: 'domestic',
    component: domestic
  },
  {
    path: '/Protection/:class',
    name: 'Protection',
    component: Protection
  },
  {
    path: '/product/:class/:index',
    name:'product',
    component:product
  },
  {
    path: '/productInfo/:class/:index/:childIndex',
    name:'productInfo',
    component:productInfo
  },
  {
    path:'/news',
    name:'news',
    component:news
  },
  {
    path:'/newsDetails/:index',
    name:'newsDetails',
    component:newsDetails
  },{
    path:'/videoCenter',
    name:'videoCenter',
    component:videoCenter
  },{
    path:'/contact',
    name:'contact',
    component:contact
  }, {
    path: '/download',
    name: 'download',
    component: download
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router
